<template>
  <van-dialog  v-model="dialogShow" style="font-size: 15px" showCancelButton title="加不上微信" show-cancel-button @confirm="noticeUserUpdateWechatIdEvent">
  <div style="margin: 20px;font-size: 12px">
      <div style="display: flex">
        <div style="margin: 5px 10px 5px 0;">类型</div>
        <van-radio-group slot="input" v-model="model.type" >
          <van-radio name="1" style="margin: 5px 0" v-if="noticeTypeList.includes(1)">通知用户修改微信</van-radio>
          <van-radio name="2" style="margin: 5px 0" v-if="noticeTypeList.includes(2)">通知用户添加我的微信</van-radio>
        </van-radio-group>
      </div>
      <div v-if="model.type==='1'">公众号将发送通知提醒用户修改微信，用户修改完毕，将会通知您</div>
      <div v-if="model.type==='2'" style="margin: 10px 0">
        <div>公众号将发送通知提醒用户添加您的微信</div>
        <div v-if="!wechatImgUrl">
          <span style="color: red">您暂未上传微信二维码，</span>
          <span style="color: #0CADF5" @click="$router.replace('/clerk/info')">前往【我的资料】修改</span>
        </div>
        <div v-else>
          <div style="margin: 5px 0">我的二维码</div>
          <div><img :src="wechatImgUrl" style="width: 50%"></div>
        </div>
      </div>
    <div style="margin-top: 10px">剩余可通知用户次数：{{3-count}}</div>
    </div>
  </van-dialog>
</template>
<script>
import {RadioGroup, Radio, Dialog, Toast} from 'vant';
import Vue from "vue";

Vue.use(RadioGroup)
    .use(Radio)

import {
  noticeUserUpdateWechatId,
  updateNoticeCount
} from "@/api/clerk/order";
import moment from "moment";

export default {
  name: "noWechat",
  props: {
  },
  components: {},
  data() {
    return {
      dialogShow: false,
      wechatImgUrl: false,
      model:{
        type:'1',
        clerkId: null,
        orderNo: null,
      },
      bannerImgUrl: null,
      count: 0,
      noticeTypeList: [],
    }
  },
  methods: {
    //图片弹窗
    show(clerkId, wechatImgUrl, orderNo, noticeTypeList) {
      this.dialogShow = true
      this.clerkId = clerkId
      this.wechatImgUrl = wechatImgUrl
      this.model.orderNo = orderNo
      this.noticeTypeList = noticeTypeList
      this.loadData()
    },
    loadData() {
      updateNoticeCount(this.model.orderNo).then((res) => {
        Toast.clear();
        const data = res.data;
        if (data.code == 0) {
          this.count = data.count;
        } else {
          Dialog.alert({
            title: "加载失败",
            message: data.msg,
          });
        }
      });
    },
    noticeUserUpdateWechatIdEvent() {
      let message = null
      if (this.model.type === '1') {
        message = "公众号将发送通知提醒用户修改\n微信号，用户修改完毕，将会通知您"
      } else if (this.model.type === '2') {
        if (!this.wechatImgUrl){
          return Dialog.alert({title: '请先上传微信二维码',})
        }
        message = "公众号将发送通知提醒用户添加您的微信号"
      }
      Dialog.confirm({
        title: "温馨提醒",
        message: message,
      }).then(() => {
        Toast.loading({
          mask: true,
          message: "请稍候...",
        });
        noticeUserUpdateWechatId(this.clerkId, this.model.type).then((res) => {
          Toast.clear();
          const data = res.data;
          if (data.code == 0) {
            Toast('已通知用户处理');
          } else {
            Dialog.alert({
              title: '通知失败',
              message: data.msg
            })
          }
        });
      });
    },

  },
  mounted() {
  }
}
</script>
<style lang="less" scoped>
</style>
